/** @format */

import React from "react";
import { Card, Text, ActionIcon, Badge, Tooltip } from "@mantine/core";
import { FileText, X } from "tabler-icons-react";
import { formatDate } from "../../../utilities/utilities";

const FileCard = ({ file, onRemove, readOnly = false }) => {
  // Get file icon based on type
  const getFileIcon = (fileType) => {
    const type = fileType?.toLowerCase() || "";
    if (type.includes("pdf")) {
      return <FileText size={24} color="#EF4444" />;
    }
    if (type.includes("doc") || type.includes("docx")) {
      return <FileText size={24} color="#3B82F6" />;
    }
    return <FileText size={24} color="#6B7280" />;
  };

  // Get file extension badge
  const getFileExtension = (fileName) => {
    const parts = fileName?.split(".") || [];
    return parts.length > 1 ? parts[parts.length - 1].toUpperCase() : "FILE";
  };

  return (
    <Card
      padding="md"
      radius="md"
      withBorder
      style={{
        borderLeft: "4px solid #46BDE1",
        transition: "all 0.2s",
        cursor: "default",
      }}
      sx={{
        "&:hover": {
          boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
        },
      }}
    >
      <div style={{ display: "flex", alignItems: "flex-start", gap: "12px" }}>
        {/* File Icon */}
        <div
          style={{
            padding: "8px",
            borderRadius: "8px",
            background: "#F3F4F6",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {getFileIcon(file.fileType || "pdf")}
        </div>

        {/* File Info */}
        <div style={{ flex: 1, minWidth: 0 }}>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "flex-start",
              marginBottom: "4px",
            }}
          >
            <Text
              size="sm"
              weight={600}
              lineClamp={2}
              style={{ flex: 1, wordBreak: "break-word" }}
            >
              {file.agreementData?.json?.titleOfAgreement ||
                "Untitled Document"}
            </Text>

            {/* Remove Button - Only show if not read-only */}
            {!readOnly && onRemove && (
              <Tooltip label="Remove file">
                <ActionIcon
                  size="sm"
                  color="red"
                  variant="subtle"
                  onClick={() => onRemove(file.id)}
                  style={{ marginLeft: "8px" }}
                >
                  <X size={16} />
                </ActionIcon>
              </Tooltip>
            )}
          </div>

          {/* File Metadata */}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
              flexWrap: "wrap",
            }}
          >
            <Badge size="xs" variant="outline" color="blue">
              {getFileExtension(file.name || file.fileName)}
            </Badge>
            {file.createdAt && (
              <Text size="xs" color="dimmed">
                {formatDate(file.createdAt)}
              </Text>
            )}

            {file.status && (
              <Badge
                size="xs"
                color={file.status === "SIGNED" ? "green" : "gray"}
                variant="light"
              >
                {file.status}
              </Badge>
            )}
          </div>

          {/* Agreement Type - More Prominent */}
          {file.agreementData?.json?.typeOfAgreement && (
            <div style={{ marginTop: "8px" }}>
              <Text size="xs" weight={500} color="dark">
                {file.agreementData?.json?.typeOfAgreement ||
                  "Unknown Agreement Type"}
              </Text>
            </div>
          )}
          {/* AIN Number */}
          {file.id && (
            <Text size="xs" color="dimmed" mt={4}>
              AIN: agreement-{file.id}
            </Text>
          )}
        </div>
      </div>
    </Card>
  );
};

export default FileCard;
